<script lang="ts" setup>
import { computed, ref, watch, reactive, toRefs, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Delete, Operation } from '@element-plus/icons-vue'
import useWebTabsStore from '@/store/webtabs'
// import Profile from '@/pages/admin/settings/profile.vue'

const router = useRouter()
const route = useRoute()
const tabsStore = useWebTabsStore()

// 弹出“个人资料”对话框
const openProfile = ref(false)

// 初始化标签页的激活值为当前路径
const editableTabsValue = ref(route.path)

// 监听路由变化，自动更新激活的 tab
watch(route, () => {
  editableTabsValue.value = route.path
})

// 获取 tab 页签列表（响应式）
const editableTabs = computed(() => tabsStore.editableTabs)

// 删除标签页
const removeTab = (targetName: string) => {
  const tabs = editableTabs.value
  let activeName = editableTabsValue.value

  if (activeName === targetName) {
    const index = tabs.findIndex((tab) => tab.name === targetName)
    const nextTab = tabs[index + 1] || tabs[index - 1]
    if (nextTab) {
      activeName = nextTab.name
    }
  }

  tabsStore.deleteWebTab(targetName)
  editableTabsValue.value = activeName
  router.push(activeName)
}

// 点击 tab 页签时跳转路由
const handleTabClick = () => {
  router.push(editableTabsValue.value)
}

// 设置图标下拉菜单事件处理
const handleSettingCommand = (command: string) => {
  if (command === 'profile') {
    openProfile.value = true
  } else if (command === 'logout') {
    localStorage.removeItem('token') // 示例处理
    window.location.href = '/login'
  }
}

import type { DrawerProps } from 'element-plus'

const drawer = ref(false)
const direction = ref<DrawerProps['direction']>('rtl')

function handleClose() {
  drawer.value = false
}

// 示例头像
const state = reactive({
  squareUrl:
      'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
})

const { squareUrl } = toRefs(state)

// 读取和保存暗黑模式
const isDarkMode = ref(false)

// 在页面加载时读取缓存的暗黑模式设置
onMounted(() => {
  const savedMode = localStorage.getItem('isDarkMode')
  if (savedMode !== null) {
    isDarkMode.value = JSON.parse(savedMode)
  }

  // 根据当前暗黑模式设置切换 body 类
  updateDarkMode(isDarkMode.value)
})

// 在暗黑模式切换时，保存状态并更新 body 类
watch(isDarkMode, (newValue) => {
  localStorage.setItem('isDarkMode', JSON.stringify(newValue))
  updateDarkMode(newValue)
})

// 更新 body 上的 dark 类
function updateDarkMode(isDark: boolean) {
  if (isDark) {
    document.body.classList.add('dark')  // 开启暗黑模式
  } else {
    document.body.classList.remove('dark')  // 关闭暗黑模式
  }
}
</script>

<template>
  <!-- 个人资料弹窗 -->
  <el-dialog v-model="openProfile" width="500" body-class="my-el-dialog-content">
    <Profile />
  </el-dialog>

  <!-- 顶部标签页 + 设置栏 -->
  <el-row :gutter="24">
    <!-- 标签页 -->
    <el-col :span="16">
      <div class="header-web-tabs">
        <el-tabs
            v-model="editableTabsValue"
            class="web-tabs"
            @tab-remove="removeTab"
            @tab-click="handleTabClick"
        >
          <el-tab-pane
              v-for="item in editableTabs"
              :key="item.path"
              :label="item.title"
              :name="item.name"
              :closable="editableTabs.length > 1"
          />
        </el-tabs>
      </div>
    </el-col>

    <!-- 操作栏 -->
    <el-col :span="5" :offset="3">
      <div class="header-actions" style="display: flex; align-items: center; gap: 12px;">
        <el-button :icon="Delete" />

        <el-dropdown @command="handleSettingCommand">
          <el-text class="mx-1" @click="openProfile = true" style="cursor: pointer">系统管理员</el-text>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="profile">个人资料</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <!-- 设置按钮下拉菜单 -->
        <el-button :icon="Operation" @click="drawer = true" />
        <el-drawer
            v-model="drawer"
            title="布局配置"
            :direction="direction"
            :before-close="handleClose"
        >
          <el-divider border-style="dashed">全局</el-divider>
          <el-switch
              v-model="isDarkMode"
              class="mb-2"
              inactive-text="暗黑模式"
          />
        </el-drawer>
      </div>
    </el-col>
  </el-row>

  <el-drawer
      v-model="drawer"
      direction="rtl"
      :before-close="handleClose"
  >
    <span>Hi, there!</span>
  </el-drawer>
</template>
